import "../css/Footer.css";
import { NavLink } from "react-router-dom";
function Footer() {
  return (
    <footer className="nxsa-footer" id="contact">
      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-col brand">
          <div className="footer-logo">
            <img src="/icon/logo_name.png" alt="NXSA" />
          </div>

          <p className="footer-desc">
            Powering Agriculture, Automation with
             intelligent, reliable, and scalable embedded and IoT solutions.
                         {/* Powering Agriculture, Electric Mobility, Renewable Energy, and Home Automation */}

          </p>

          <div className="footer-socials">

            <a href="https://www.youtube.com/@NXSAPRIVATELIMITED" target="_blank" rel="noopener noreferrer">
              <img src="/icon/youtube.png" alt="YouTube" />
            </a>

            {/* <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
              <img src="/icon/linkedin.png" alt="LinkedIn" />
            </a> */}

            <a href="https://www.instagram.com/nxsa.private.limited?igsh=cXpqaXh2dGdhZ2Nn" target="_blank" rel="noopener noreferrer">
              <img src="/icon/instagram.png" alt="Instagram" />
            </a>

          </div>
        </div>

        {/* COMPANY */}
        <div className="footer-col">
          <h4>Company</h4>
          <ul className="footer-menu">
            <li><NavLink to="/#home">Home</NavLink></li>
            <li><NavLink to="/#about">About Us</NavLink></li>
            <li><NavLink to="/#services">Our Services</NavLink></li>
            <li><NavLink to="/#products">Our Products</NavLink></li>
            <li><NavLink to="/careers">Careers</NavLink></li>
          </ul>
        </div>

        {/* FOCUS AREAS */}
        <div className="footer-col">
          <h4>Our Focus Areas</h4>
          <ul>
            <li>Smart Agriculture Systems</li>
            {/* <li>Electric Mobility & EV Platforms</li>
            <li>Renewable Energy Monitoring</li>
            <li>Home Automation & Smart Living</li> */}
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-col">
          <h4>Contact Us</h4>

          <div className="contact-item">
            <img src="/icon/address.png" alt="Address" />
            <p>
              2nd Floor, Suman Ankur, Sahyadri Farm, Sr No 82/1,
              Baner Gaon, Pune, Haveli, Maharashtra, India,
              <br />411045.
            </p>
          </div>

          <div className="contact-item">
            <img src="/icon/mail.png" alt="Email" />
            <p>nxsaassist@gmail.com</p>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} NXSA. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
